<template>
  <div>
    <vx-card title="حدث خطأ" class="mb-2" title-color="danger" v-if="Object.keys(errors_values).length">

      <div v-for="(key, index) in Object.keys(errors_values)" :key="index">

        <span v-for="(error, index) in errors_values[key]" :key="index" class="text-danger">
          {{ error }}
        </span>
      </div>

    </vx-card>
    <vx-card>
      <div class="vx-row">
        <div class="vx-col w-full flex justify-between">
          <h1>تعديل منتج</h1>

        </div>
      </div>
      <div class="mb-5">&#8203;</div>
      <h4 class="mt-8">صور المنتج</h4>
      <div class="vx-row bottom-seperator">
        <div class="vx-col my-1 w-full mb-6">
          <div class="con-img-upload flex" id="images" v-if="media.length">
            <div class="img-upload" v-for="(image, index) in media" :key="index">
              <button type="button" class="btn-x-file" @click="spliceFile(index, image.id)">
                <i translate="translate" class="material-icons notranslate">clear</i>
              </button>
              <img v-if="image.blob" :src="image.blob" style="max-width: none; max-height: 100%" />
              <img v-else :src="image.full_path" style="width: 100%" />
            </div>
          </div>
          <file-upload ref="upload" :multiple="true" v-model="product.media" class="vs-button bg-primary mt-5"
            post-action="/post.method" put-action="/put.method" extensions="jpg,gif,png,webp" :maximum="3"
            @input-filter="inputFilter" @input-file="inputFile">
            تنزيل صورة
          </file-upload>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col my-3 sm:w-1/2 w-full mb-2">
          <div>
            <div class="vx-row">
              <div class="vx-col my-3 sm:w-full w-full mb-2">
                <vs-input class="w-full" label-placeholder="إسم المنتج" v-model="product.name" />
              </div>
            </div>
            <div class="vx-row mt-8">
              <div class="vx-col my-3 sm:w-1/2 w-full mb-2">
                <vs-input class="w-full" label-placeholder="رقم SKU" v-model="product.sku" />
              </div>
              <div class="vx-row sm:w-1/2 w-full pl-10 mb-2">
                <div class="mb-2"><label for="">العلامة التجارية</label></div>
                <select v-model="product.brand_id" class="w-full h-12">
                  <option v-for="brand in brands" :key="brand.id" :value="brand.id">
                    {{ brand.name }}
                  </option>
                </select>
              </div>
              <div class="vx-row w-full mt-10">
                <div class="vx-col my-3 sm:w-1/3 w-full ml-5 mb-10">
                  <vs-input type="number" class="w-full" label-placeholder="سعر المنتج" v-model="product.price" />
                </div>
                <div class="vx-col my-3 sm:w-1/3 w-full">
                  <vs-input type="number" class="w-full" label-placeholder="السعر بعد التخفيض"
                    v-model="product.new_price" />
                </div>
                <div class="vx-col my-3 sm:w-1/4 w-full">
                  <vs-input type="number" class="w-full" label-placeholder="الكمية" v-model="product.quantity" />
                </div>
              </div>
            </div>
          </div>

          <!-- category -->
          <div class="vx-row mt-8 mb-20">
            <div class="vx-col sm:w-1/2 w-full mb-6">
              <div class="mb-2"><label for="">القسم الرئيسي</label></div>
              <v-select label="name" data-vv-as="القسم الرئيسي" v-model="product.category" :options="categories"
                v-validate="'required'" :dir="$vs.rtl ? 'rtl' : 'ltr'" name="mainCatgeory" class="w-full"></v-select>
            </div>
            <div class="vx-col sm:w-1/2 w-full mb-6">
              <div class="mb-2"><label for="">القسم الفرعي</label></div>
              <v-select label="name" data-vv-as="القسم الفرعي" v-model="product.sub_category_id"
                :reduce="(item) => item.id" :options="product.category.sub_categories" v-validate="'required'"
                :dir="$vs.rtl ? 'rtl' : 'ltr'" name="subCategory" class="w-full"></v-select>
            </div>
            <div class="vx-col sm:w-full w-full mb-6">
              <div class="mb-2"><label for="">نسبة الزيادة</label></div>
              <vs-input data-vv-as="نسبة الزيادة" type="number" class="w-full"
                    name="percentage" label-placeholder="نسبة الزيادة" v-model="product.percentage" />
                  <span class="text-danger text-sm" v-show="errors.has('percentage')">{{
                  errors.first("percentage")
                  }}</span>
             
            </div>
          </div>
        </div>

        <!-- product descreption -->

        <div class="vx-col mt-3 sm:w-1/2 w-full mb-6 seperator">
          <label for="">وصف المنتج</label>
          <vs-textarea class="mt-3 pb-20" rows="10" placeholder="وصف المنتج بالكامل و لما يحمله من خصائص"
            v-model="product.description" />
          <div class="vx-row sm:w-full w-full">
            <vs-checkbox class="mx-5" v-model="product.is_new">
              هل المنتج جديد
            </vs-checkbox>
            <vs-checkbox class="mx-5" v-model="product.is_featured">
              تمييز في الصفحة الرئيسية
            </vs-checkbox>
          </div>
        </div>
      </div>

      <!-- submitting -->
      <div class="vx-row mt-8 btn-alignment">
        <div class="vx-col sm:w-full w-full mb-6">
          <vs-button class="mr-5 text-lg py-4" @click="$router.go(-1)" color="warning" type="border">إلغاء</vs-button>

          <vs-button class="mr-5 text-lg px-16 py-4" @click="submit" color="success" type="filled">تعديل</vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import VueUploadComponent from "vue-upload-component";
// Store Module
import moduleProduct from "@/store/products/moduleProduct.js";
export default {
  components: {
    vSelect,
    "file-upload": VueUploadComponent,
  },
  data() {
    return {
      errors_values: {},
      product: {
        name: "",
        sku: "",
        price: null,
        new_price: null,
        brand_id: "",
        quantity: null,
        media: [],
        deleted_media: [],
        description: "",
        is_new: false,
        is_featured: false,
        category: "",
        sub_category_id: "",
        percentage:''
      },
      media: [],
      category: {},
      // Main category come from db
    };
  },
  computed: {
    categories() {
      return this.$store.state.product.Categories;
    },
    productData() {
      return this.$store.state.product.product;
    },
    brands() {
      return this.$store.state.product.brands;
    },
  },
  methods: {
    spliceFile(index, id) {
      this.product.deleted_media.push(id);
      this.media.splice(index, 1);
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile.size / 1024.0 > 5000) {
        this.$vs.notify({
          title: "حدث خطأ",
          text: "يجب أن لا يكون حجم الصورة أكبر من 5mb",
          color: "danger",
        });
        return prevent();
      }
      if (newFile && !oldFile) {
        if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
          this.$vs.notify({
            title: "حدث خطأ",
            text: "يجب أن يكون الملف بإمتداد صورة صحيح",
            color: "danger",
          });
          return prevent();
        }
      }
      newFile.blob = "";
      let URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);
      }
    },
    inputFile(newFile) {
      this.media.push(newFile);
    },

    submit() {
      //to diffrentiate between the deleted new media and the deleted old media since the old media's id i s a number
      let deleted_media = this.product.deleted_media.filter(this.numberOnly);

      this.$validator.validateAll().then((result) => {
        if (result) {
          var bodyFormData = new FormData();
          bodyFormData.set("name", this.product.name);
          bodyFormData.set("sku", this.product.sku);
          bodyFormData.set("price", this.product.price);
          bodyFormData.set("new_price", this.product.new_price || null);
          bodyFormData.set("brand_id", this.product.brand_id);
          bodyFormData.set("description", this.product.description);
          bodyFormData.set("quantity", this.product.quantity);
          bodyFormData.set("is_new", this.product.is_new ? 1 : 0);
          bodyFormData.set("is_featured", this.product.is_featured ? 1 : 0);
          bodyFormData.set("sub_category_id", this.product.sub_category_id);
          bodyFormData.set("category_id", this.product.category.id);
          bodyFormData.set("percentage", this.product.percentage);
          deleted_media.forEach((item) => bodyFormData.append("deleted_media[]", item))
          bodyFormData.set("id", this.productData.id);

          for (var i = 0; i < this.product.media.length; i++) {
            let file = this.product.media[i].file;
            bodyFormData.append("media[" + i + "]", file);
          }

          this.$store
            .dispatch("product/updateProduct", bodyFormData)
            .then(() => {
              this.$vs.notify({
                title: "تم بنجاح",
                text: "تم تعديل المنتج بنجاح",
                color: "success",
              });
              this.$router.push({ name: "products" });
            })
            .catch((err) => {

              this.errors_values = err.response.data.errors;
              this.$vs.notify({
                title: "حدث خطأ",
                text: err.response.data.message,
                color: "danger",
              });
            });
        }
      });
    },
  },
  mounted() {
    this.product.name = this.productData.name;
    this.product.sku = this.productData.sku;
    this.product.price = this.productData.price;
    this.product.new_price = this.productData.new_price;
    this.product.brand_id = this.productData.brand_id;
    this.product.quantity = this.productData.quantity;
    this.product.description = this.productData.description;
    this.product.is_new = this.productData.is_new;
    this.product.is_featured = this.productData.is_featured;
    this.product.category = this.productData.category;
    this.product.percentage = this.productData.percentage;
    this.product.sub_category_id = this.productData.sub_category.id;
    this.media = this.productData.media;
  },
  created() {
    if (!moduleProduct.isRegistered) {
      this.$store.registerModule("product", moduleProduct);
      moduleProduct.isRegistered = true;
    }
    this.$store.dispatch("product/fetchCategories");
    this.$store.dispatch("product/fetchBrands");
  },
};
</script>

<style scoped>
.product-image {
  cursor: pointer;
  transition: all 0.3s;
}

.product-image:hover {
  transform: scale(0.9);
}

.image-container {
  border-radius: 10px;
  margin: 10px;
  width: 200;
  height: 200px;
  border: 2px solid transparent;
}

.image-container:hover {
  border: 2px solid rgba(255, 0, 0, 0.39);
}

.seperator {
  border-left: 1px solid rgb(204, 204, 204);
}

.bottom-seperator {
  border-bottom: 1px solid rgb(204, 204, 204);
  margin-bottom: 4em;
}

.btn-alignment {
  text-align: right;
}

.prod-copy-btn:hover {
  color: rgb(0, 174, 255);
  cursor: pointer;
}
</style>
